import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Existe um período de teste grátis?",
    a: "Sim! Oferecemos 7 dias de trial grátis com até 5 números. É necessário cadastrar um cartão de crédito, mas você só será cobrado após o período de teste. Cancele a qualquer momento sem custos.",
  },
  {
    q: "Vou precisar de criar as mensagens do robô?",
    a: "Não. O nosso sistema gera todas as conversas, áudios e figurinhas automaticamente com inteligência artificial. Você não precisa configurar nada.",
  },
  {
    q: "Posso disparar para os meus próprios contatos?",
    a: "Sim. A Agenda de Contatos permite importar números reais, organizá-los por tags e configurar disparos automáticos para pessoas que já conhecem o seu chip — aumentando o engajamento orgânico.",
  },
  {
    q: "O que são os stories automáticos?",
    a: "O WarmZapp publica Status/Stories no WhatsApp automaticamente ao longo do dia — alternando entre textos coloridos e imagens. Isso simula uma conta ativa e melhora a reputação do número.",
  },
  {
    q: "Como funcionam os grupos de aquecimento?",
    a: "Você pode cadastrar os seus próprios grupos de WhatsApp no painel. Os seus números entram automaticamente nesses grupos e trocam mensagens, simulando interação social real. O sistema valida os links antes de cadastrar.",
  },
  {
    q: "O que é a esteira de fases?",
    a: "É a progressão automática Cold → Warm → Hot → Mature. Cada perfil tem uma duração definida e, ao terminar, o chip é automaticamente promovido para o próximo nível de aquecimento.",
  },
  {
    q: "O que são os contatos oficiais verificados?",
    a: "São números de grandes empresas (bancos, operadoras, serviços) com os quais os seus chips trocam mensagens automaticamente, aumentando a diversidade e credibilidade das interações.",
  },
  {
    q: "Posso cancelar a qualquer momento?",
    a: "Sim, sem fidelidade nem taxas de cancelamento. Cancele quando quiser diretamente no painel.",
  },
  {
    q: "O meu chip nunca será banido?",
    a: "Reduzimos os riscos para perto de zero simulando uso real — textos, áudios, figurinhas, stories e participação em grupos com intervalos humanos. No entanto, o WhatsApp tem sempre a palavra final sobre qualquer conta.",
  },
  {
    q: "Quantos números posso conectar?",
    a: "O trial grátis inclui até 5 números. Após o trial, o plano base começa em $19/mês com 2 números. Pode adicionar quantos precisar por $9/mês cada, além de ativar a Rede Global por $5/mês por chip.",
  },
  {
    q: "Como funciona a Rede Global?",
    a: "Os seus números conversam com a nossa rede de chips maturados e reais espalhados globalmente, gerando interações orgânicas e diversificadas que blindam a reputação do seu número.",
  },
];

const FAQ = () => (
  <section id="faq" className="py-24 border-t border-warmz-glass-border/20">
    <div className="container mx-auto px-4 md:px-8 max-w-3xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="text-center mb-16"
      >
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground">
          Perguntas <span className="gradient-text-fire">Frequentes</span>
        </h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="glass-card border border-warmz-glass-border/30 rounded-xl px-6 overflow-hidden"
            >
              <AccordionTrigger className="text-left font-semibold text-foreground text-sm hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-sm pb-5 leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </div>
  </section>
);

export default FAQ;
